import { Component, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { AppState } from "src/app/state/app.state";
import { getShowSpinner } from "./state/spinner.selectors";

@Component({
    selector: "app-kiosk-spinner",
    templateUrl: "./spinner.component.html",
    styleUrls: ["./spinner.component.scss"],
    standalone: false
})
export class KioskSpinnerComponent implements OnInit {
	public show = false;

	constructor(private store: Store<AppState>) {}

	ngOnInit(): void {
		this.store.pipe(select(getShowSpinner)).subscribe((_) => {
			this.show = (_ === true);
		});
	}
}
